import {Listener, LongId, Util, UUID} from 'yougile-util'
import {ComponentUpdater} from './index'

export const ListenerUpdater: (
  listener: Listener<() => void>
) => ComponentUpdater = listener => {
  const listenerIds = new Map<UUID, LongId>()
  return {
    displayName: `Listener`,
    onMount(update: () => void): UUID {
      const key = Util.UUID()
      listener
        .addListener(() => {
          update()
        })
        .then(id => {
          listenerIds.set(key, id)
        })

      return key
    },
    onUnmount(key): void {
      const cleanup = async () => {
        const listenerId = listenerIds.get(key)
        if (listenerId) {
          listener.removeListener(listenerId)
          listenerIds.delete(key)
        } else {
          await Util.wait(500)
          cleanup()
        }
      }
      cleanup()
    }
  }
}
